export default class IntercomSingleton {
  private static instance: IntercomSingleton;
  private booted: boolean;

  private constructor() {
    this.booted = false;
    this.boot();
  }

  public boot(): void {
    if (typeof window.Intercom !== "function") return;
    window.Intercom("boot", {
      api_base: "https://api-iam.intercom.io",
      app_id: "s0mg59ro"
    });
    this.booted = true;
  }

  public static getInstance(): IntercomSingleton {
    if (!IntercomSingleton.instance) {
      IntercomSingleton.instance = new IntercomSingleton();
    }
    return IntercomSingleton.instance;
  }

  public identify(userData: {
    name: string;
    user_id: string;
    email: string;
    created_at: number;
    avatar: {
      type: string;
      image_url: string;
    };
    suno_env: string;
    user_role: string;
    user_groups: string;
    company:
      | {
          company_id: string;
          name: string;
          go_live_date?: number;
          new_customer?: boolean;
          previous_oms?: string;
        }
      | undefined;
  }): void {
    if (typeof window.Intercom !== "function") return;
    if (!IntercomSingleton.instance.booted) {
      IntercomSingleton.instance.boot();
    }
    window.Intercom("update", userData);
  }
  public logout() {
    if (typeof window.Intercom !== "function") return;
    window.Intercom("shutdown");
    this.booted = false;
  }
}

declare global {
  interface Window {
    Intercom: {
      (command: string, params?: any): any;
    };
  }
}
